<template>
    <div>
        <el-upload
            ref="elUpload"
            :action="actionUrl"
            :list-type="listType"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :name="name"
            :headers="headers"
            :accept="accept"
            :before-upload="beforeUpload"
            :limit="limit"
            :show-file-list="false"
            :on-exceed="onExceed"
            :file-list="fileList"
            :on-success="onSuccess"
            :data="otherData"
        >
            <img
                slot="trigger"
                :src="pic"
            />
            <!-- <div class="" slot="file" slot-scope="{file}">
			<img :src="file.url" alt="">
			<video :src="file.url"></video>
		</div> -->
        </el-upload>
        <div slot="tip" class="el-upload__tip">{{ tip }}</div>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "ImageUpload",
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            name: "imgFile",
            listType: "picture-card",
            actionUrl: "/api/common/upload",
            headers: {
                Authorization: "",
            },
            otherData: {},
            accept: this.acceptType,
            limit: this.maxNumber,
            fileList: [],
			fileListTemp: [], // 中转
        };
    },
    props:['imageList','pic','tipInfo','maxNumber','acceptType'],
    computed: {
        tip: function () {
            return this.tipInfo;
        },
    },
    watch: {
        imageList: function () {			
            if (this.imageList) {
                this.fileList = JSON.parse(this.imageList);
				// console.log('typeof ===',typeof this.fileList)
				this.fileListTemp = JSON.parse(this.imageList);
				this.$emit('updateImg',this.fileListTemp);
            } else {
                this.fileList = [];
				this.fileListTemp = [];
            }
        },
    },
    created() {	
        if (this.imageList) {
            this.fileList = JSON.parse(this.imageList);
			this.fileListTemp = JSON.parse(this.imageList);
        } else {
            this.fileList = [];
			this.fileListTemp = [];
        }
    },
    methods: {
        clearFileList() {
            this.$refs["elUpload"].clearFiles();
        },
        handleRemove(file, fileList) {
            // console.log('删除', file);
            this.fileList.forEach((ele, idx) => {
                if (ele.name == file.name) {
                    this.fileList.splice(idx, 1);
					this.fileListTemp.splice(idx,1);
                }
            });
			this.$emit('updateImg',this.fileListTemp);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUpload(file) {
        },
        onExceed(files, fileList) {
            this.$message.warning("最多可以上传" + this.limit + "张图片");
        },
        onSuccess(response, file, fileList) {
			// console.log('this.fileList===',this.fileList,typeof this.fileList)
            if (response.code === 200) {
                // this.fileList.push({
                //     name: response.result.filename,
                //     path: response.result.url,
                //     filetype: response.result.filetype,
                //     url: this.$publicData.imgUrl + response.result.url,
                // });
				this.fileListTemp.push({
					name: response.result.filename,
                    path: response.result.url,
                    filetype: response.result.filetype,
                    url: this.$publicData.imgUrl + response.result.url,
				})
				this.$emit('updateImg',this.fileListTemp);
            } else {
                this.$message.error(response.message);
                fileList.splice(
                    fileList.findIndex((item) => item.uid === file.uid),
                    1
                );
            }
        },
    },
};
</script>

<style scoped>
/deep/.el-upload--picture-card {
    width: 167px;
    height: 98px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}
</style>
